module.exports = __webpack_public_path__ + "static/og-b9c54b9f067bdbea074a53c273f36ca4.png";